import { useMonitor } from '../use-monitor';

export function useMonitorDeclineIssueSubmit() {
  return useMonitor('decline-issue-submit');
}
